import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../controllers/auth/UseAuth";
import { Settings } from "./Settings";
import { Competitions } from "./Competitions";
import ts from "typescript";
import { NewCompetition } from "./NewCompetitionPopup";
import { EventSettings } from "./EventSettings";
import { MainPopupSettings } from "./MainSettingsPopup";

function DashboardView() {
  const [adminSettings, setAdminSettings] = useState([]);
  const [competitionArr, setcompetitionArr] = useState([]);
  const [addCompetitionPopupShowing, setaddCompetitionPopupShowing] = useState(false);
  const [addGeneratorSettingsShowing, setaddGeneratorSettingsPopupShowing] = useState(false);
  const [competitionsShowing, setCompetitionsShowing] = useState(true);
  const [competitionsSettingsShowing, setCompetitionsSettingsShowing] = useState(false);
  const [currentMonthNumber, setCurrentMonthNumber] = useState(Number(new Date().getMonth()) + 1);
  const [currentYearNumber, setcurrentYearNumber] = useState(Number(new Date().getFullYear()) + 1);
  const [yearsFixed, setYearsFixed] = useState(Number(new Date().getFullYear()) + 1);
  const [yearsArray, setYearsArray] = useState(Array.from(new Array(20),(val, index) => yearsFixed - index));
  const [currentElemSelected, setCurrentElemSelected] = useState([] as any);
  const [globalUpdates, setGlobalUpdates] = useState(0);
  
  useEffect(() => {
    const settingsUrl = "/api/settings/list";
    let competitionsUrl = "/api/competitions/list?month=" + currentMonthNumber;

    const fetchData = async () => {
        try {
            const settings_response = await fetch(settingsUrl);
            const settings_json = await settings_response.json();

            const competition_response = await fetch(competitionsUrl);
            const competition_json = await competition_response.json();

            competition_json.sort(function(a: any, b: any) {
              let c = new Date(a.starts_at_date);
              let d = new Date(b.starts_at_date);
              
              // @ts-ignore
              return c-d;
            });
            
            setAdminSettings(settings_json);
            setcompetitionArr(competition_json);
          } catch (error) {
            console.log("error", error);
          }
        };

        fetchData();
    }, [addCompetitionPopupShowing, globalUpdates, currentMonthNumber, addGeneratorSettingsShowing]);

    const openNewCompetitionPopup = () => {
      setaddCompetitionPopupShowing(true);
    }

    const openGeneratorSettingsPopup = () => {
      setaddGeneratorSettingsPopupShowing(true);
    }

    const onGlobalUpdatesIncrement = () => {
      setGlobalUpdates(globalUpdates+1);
    }

    const handleNewCompetitionCloseEvent = () => {
      setaddCompetitionPopupShowing(false);
    }

    const handleGeneratorSettingsCloseEvent = () => {
      setaddGeneratorSettingsPopupShowing(false);
    }

    const handleElemChange = (elem: any) => {
      setCompetitionsShowing(false);
      setCompetitionsSettingsShowing(true);

      let array_like = [];
      array_like.push(elem);
      setCurrentElemSelected(array_like);
    }

    const onSetMonth = (e: any) => {
      let value = Number(e.target.value);

      setCurrentMonthNumber(value);
    }

    const onSetYear = (e: any) => {
      let value = Number(e.target.value);

      setcurrentYearNumber(value);
    }

    const handleBack = () => {
      setCompetitionsShowing(true);
      setCompetitionsSettingsShowing(false);

      setCurrentElemSelected([]);
    }

  return (
      <div className="pfgame-dashboard-view">
        <div className="pfgame-dashboard-view__content-wrapper">
          <nav className="pfgame-dashboard-view__content-wrapper--header mb-5">
            <div className="d-flex flex-justify-between flex-align-vertical-center">
              <h4>Contest Data</h4>
              <button type="submit" className="pfgame-main-button btn-gray" onClick={openNewCompetitionPopup}>Create New</button>
            </div>
          </nav>

          <div className="pfgame-dashboard-view__content-wrapper--event-data-table">
            <div className="pfgame-dashboard-view__content-wrapper--infograph">
              <div className="date-info">
                <div className="info-like-icon">
                  1
                </div>

                <div className="info-description">
                  = The event's start date (quick overview format).
                </div>
              </div>

              <div className="delete-info">
                <div className="info-like-icon">
                  🗑
                </div>

                <div className="info-description">
                  = Quickly delete events by clicking the "delete" icon.
                </div>
              </div>

              <div className="credit-info">
                <div className="info-like-icon">
                  🟡
                </div>

                <div className="info-description">
                  = The amount of credits served for the event.
                </div>
              </div>
            </div>

            <div className="pfgame-dashboard-view__content-wrapper--infograph">
              <div className="date-info">
                <div className="info-like-icon green-info">
                  
                </div>

                <div className="info-description">
                  = The event is upcoming or active.
                </div>
              </div>

              <div className="date-info">
                <div className="info-like-icon gray-info">
                  
                </div>

                <div className="info-description">
                  = The event has expired (by date).
                </div>
              </div>

              <div className="date-info">
                <div className="info-like-icon red-info">
                  
                </div>

                <div className="info-description">
                  = The event was disabled/deleted manually.
                </div>
              </div>
            </div>

            <p>
              <span className="mr-8"><b className="mr-8">S:</b> The event's start date (YYYY-MM-DD hh:mm 📅).</span>
              <span><b className="mr-8">E:</b> The event's end date (YYYY-MM-DD hh:mm 📅).</span>
            </p>

            <div>
              <label className="mr-8">Show a specific year:</label>

              <select name="show-years" className="pfgame-main-input mb-5 mr-8" onChange={onSetYear}>
                {yearsArray.map((year, index) => (
                  <option value={year} selected={(currentYearNumber == year) ? true : false}>{year}</option>
                ))}
              </select>

              <label className="mr-8">Show a specific month:</label>

              <select name="show-months" className="pfgame-main-input mb-5" onChange={onSetMonth}>
                <option value="1" selected={(currentMonthNumber == 1) ? true : false}>January</option>
                <option value="2" selected={(currentMonthNumber == 2) ? true : false}>February</option>
                <option value="3" selected={(currentMonthNumber == 3) ? true : false}>March</option>
                <option value="4" selected={(currentMonthNumber == 4) ? true : false}>April</option>
                <option value="5" selected={(currentMonthNumber == 5) ? true : false}>May</option>
                <option value="6" selected={(currentMonthNumber == 6) ? true : false}>June</option>
                <option value="7" selected={(currentMonthNumber == 7) ? true : false}>July</option>
                <option value="8" selected={(currentMonthNumber == 8) ? true : false}>August</option>
                <option value="9" selected={(currentMonthNumber == 9) ? true : false}>September</option>
                <option value="10" selected={(currentMonthNumber == 10) ? true : false}>October</option>
                <option value="11" selected={(currentMonthNumber == 11) ? true : false}>November</option>
                <option value="12" selected={(currentMonthNumber == 12) ? true : false}>December</option>
              </select>
            </div>

            <Competitions competitionElemProps={{ show: competitionsShowing, competitionData: competitionArr, handleElemSelect: handleElemChange, handleUpdate: onGlobalUpdatesIncrement }} />

            <EventSettings competitionElemProps={{ show: competitionsSettingsShowing, competitionData: currentElemSelected, handleBackButton: handleBack, handleUpdate: onGlobalUpdatesIncrement }} />
          </div>

          <nav className="pfgame-dashboard-view__content-wrapper--header mb-5">
            <div className="d-flex flex-justify-between flex-align-vertical-center">
              <h4>Contest Generator Main Settings</h4>
              <button type="submit" className="pfgame-main-button btn-gray" onClick={openGeneratorSettingsPopup}>Edit Settings</button>
            </div>
          </nav>
        </div>

        <NewCompetition competitionProps={{ show: addCompetitionPopupShowing, handleClose: handleNewCompetitionCloseEvent }} />
        <MainPopupSettings competitionProps={{ show: addGeneratorSettingsShowing, handleClose: handleGeneratorSettingsCloseEvent, settingsData: adminSettings }} />
      </div>
    );
}
  
export { DashboardView };